import { useNavigate } from "react-router-dom";
import { createArticle, uploadCover } from "../../../api/articles";
import type { ArticleCategory, DurationValue } from "../../../types/article";
import { useArticleEditor } from "../../../hooks/useArticleEditor";
import { useToast } from "@hiya/ui";
import { ArticleEditorForm } from "../../../components/articles/ArticleEditorForm";

export function CreateArticlePage() {
  const navigate = useNavigate();
  const { toast, showToast } = useToast();
  const { state, actions } = useArticleEditor({ requireCoverFile: true });

  async function handlePublish() {
    if (!state.isValid || state.saving) return;
    actions.setSaving(true);

    try {
      const article = await createArticle({
        title: state.heading,
        category: state.category as ArticleCategory,
        read_time_minutes: state.duration as DurationValue,
        body: actions.buildBodyBlocks(),
      });

      if (state.coverFile) {
        await uploadCover(article.id, state.coverFile);
      }

      showToast("New article published");
      navigate("/dashboard/content/articles");
    } catch {
      showToast("Failed to publish article");
    } finally {
      actions.setSaving(false);
    }
  }

  return (
    <ArticleEditorForm
      title="Create Article"
      toast={toast}
      state={state}
      actions={actions}
      onBack={() => navigate(-1)}
      onPublish={handlePublish}
    />
  );
}
